import React from 'react';
import { ScreenerAccountFilter } from 'components/Filter';
import IdInput from 'components/Filter/IdInput';

export const ProfessionalScreeningFilters = [
  <IdInput />,
  <ScreenerAccountFilter
    alwaysOn
    source="screener_account_id"
    label="Screening Recruiter"
  />,
];
